import { GetSellerFiltersResp } from 'types/api/response/get-seller-filters-resp'

import { api } from './api'

export const getSellerFilters = () => api.get<GetSellerFiltersResp>('/closet/seller_filters')
